import { Button } from 'twyne-new.ui';

export default function AuthButton({ children, link, ...rest }) {
  return <Button color='accent' variant={link ? 'ghost' : 'default'} className='flex justify-center' size='lg' {...rest}>
    {children}
  </Button>
}
